import React from "react";
import classnames from "classnames";
import { withState } from "recompose";

const enhanceWithFocus = withState("focus", "setFocus", false);
const Checkbox = enhanceWithFocus(
  ({
    id,
    focus,
    setFocus,
    label,
    children,
    type = "checkbox",
    readOnly,
    className,
    indeterminate = false,
    onBlur = () => undefined,
    onFocus = () => undefined,
    flat,
    meta,
    boxed,
    error,
    ...props
  }) => {
    const prefixCls = type;
    const inputCls = `${prefixCls}__input`;
    const checkCls = `${prefixCls}__check`;
    const labelCls = `${prefixCls}__label`;

    const componentCls = classnames(prefixCls, className);

    const checkComponentCls = classnames(
      {
        [`${checkCls}--checked`]: readOnly &&
          (props.checked || props.defaultChecked),
        [`${checkCls}--readonly`]: readOnly,
        [`${checkCls}--indeterminate`]: indeterminate,
        [`${checkCls}--focus`]: focus,
      },
      checkCls
    );

    const handleBlur = e => {
      setFocus(false);
      onBlur(e);
    };

    const handleFocus = e => {
      setFocus(true);
      onFocus(e);
    };

    return (
      <label htmlFor={id} className={componentCls}>
        {readOnly
          ? null
          : <input
              id={id}
              className={inputCls}
              type={type}
              onFocus={handleFocus}
              onBlur={handleBlur}
              {...props}
              ref={input => {
                if (input) {
                  input.indeterminate = props.indeterminate;
                }
              }}
            />}
        <div className={checkComponentCls} />
        <div className={labelCls}>
          {label ? label : children}
        </div>
      </label>
    );
  }
);

export default Checkbox;



// WEBPACK FOOTER //
// ./casper/sass/components/checkbox/checkbox.js